// extracted by mini-css-extract-plugin
export var standaloneTable = "_eg-0";
export var standaloneTableWithBodyFill = "_eg-1";
export var withExtraHeader = "_eg-2";